import styled from 'styled-components';

import { OrbitTheme } from '../../../themes/architecture/orbit-theme.interface';
import {FP_VOUCHER_TYPES} from "../../../../common/const/free_play_consts";

let freePlayBgImage = (theme: OrbitTheme, freePlayType: FP_VOUCHER_TYPES) => {
    switch (freePlayType) {
        case FP_VOUCHER_TYPES.FreeSpin:
            return theme.images.freePlay.typeFS.toString();
        case FP_VOUCHER_TYPES.FreePlay:
            return theme.images.freePlay.typeFP.toString();
        case FP_VOUCHER_TYPES.FreeJackpotSpin:
            return theme.images.freePlay.typeJFS.toString();
        case FP_VOUCHER_TYPES.FreeJackpotPlay:
            return theme.images.freePlay.typeJFP.toString();
        default:
            return "";
    }
}

export const GameItemFpThumbBox = styled.div<{freePlayType?: FP_VOUCHER_TYPES, useSquareIcons?: boolean}>`
    position: absolute;
    bottom: ${({useSquareIcons}) => useSquareIcons ? "-1.5rem": "0.5rem"};
    right: ${({useSquareIcons}) => useSquareIcons ? "-1.5rem": "-0.5rem"};
    display: ${({freePlayType}) => freePlayType ? "block": "none"};
    width: 3rem;
    height: 3rem;
    background-image: ${({theme, freePlayType}) => 'url("' + freePlayBgImage(theme, freePlayType) + '")' };
`;
